import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import styles from "./styles.module.scss";
import Button from "../common/Button";
import cx from "classnames";
import GainfulLogo from "../../../../static/images/checkout/gainful.svg";
export const safeGetItem = (key, defaultValue) => {
    let val = defaultValue || null;
    const strValue = localStorage.getItem(key);
    if (strValue) {
        try {
            val = JSON.parse(strValue);
        }
        catch (e) {
            // couldnt parse string
        }
    }
    return val;
};
export const RESPONSE_KEY = "prospre/response";
export const MACROS_KEY = "prospre/macros";
const GroceryList = ({ grocery_list, food_lookup_table }) => {
    return (_jsx("div", { className: styles.container, children: Object.keys(grocery_list).map((aisle, i) => {
            const ingredients = grocery_list[aisle];
            return (_jsxs("div", { className: styles.section, children: [_jsx("h2", { className: cx({ [styles.aisle]: !!i }), children: aisle }), ingredients.map((ingredient) => {
                        const food = food_lookup_table[ingredient.ID];
                        return (_jsxs("div", { className: styles.item, children: [_jsx("div", { style: { height: "12px", width: "12px", border: "1px solid #aaa", borderRadius: "1px" } }), food.Name] }));
                    })] }));
        }) }));
};
const MyComponent = () => {
    const [response, setResponse] = useState(safeGetItem(RESPONSE_KEY, {}));
    return (_jsxs("div", { children: [_jsxs("div", { className: styles.header, children: [_jsx("img", { className: styles.gainfulWordmark, src: GainfulLogo }), _jsx(Button, { color: "green", className: styles.printButton, onClick: () => window.print(), children: "Download or print list" })] }), _jsx("div", {}), _jsx(GroceryList, { grocery_list: response.grocery_list, food_lookup_table: response.food_lookup_table })] }));
};
export default MyComponent;
